<template>
  <div>
    <div v-if="!profileChanged">
      <div class="mb-4">
        <h6>{{ getFormTitle() }}</h6>
      </div>

      <el-row>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 8 : 8">
          <dg-text-field
              :control="control"
              :disabled="editMode"
              :field_span="22"
            :label_span="22"
              field_mark="required"
              label="username"
              name="username"
              placeholder="GreenLeaf"
              rules="required"></dg-text-field>
        </el-col>

        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 8 : 8">
          <dg-text-field
              :control="control"
              :field_span="22"
            :label_span="22"
              field_mark="required"
              label="display_name"
              name="display_name"
              placeholder="Leaf That Never Dies"
              rules="required"></dg-text-field>
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 8 : 8">
          <dg-select-field
              :control="control"
              :disabled="editMode"
              :field_span="22"
            :label_span="22"
              :options="profilesOptionsList"
              :translateLabels="false"
              @amUpdated="profileUpdated"
              field_mark="required"
              label="profile"
              name="user_profile_id"
              rules="required"
              v-if="!isForCurrentActiveUser"></dg-select-field>
        </el-col>
      </el-row>

      <el-row>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 8 : 8">
          <dg-text-field
              :control="control"
              :field_span="22"
            :label_span="22"
              field_mark="required"
              htmlautocomplete="new-password"
              label="email"
              name="email"
              placeholder="your@email.com"
              rules="required"></dg-text-field>
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 8 : 8">
          <dg-text-field
              :control="control"
              :field_span="22"
            :label_span="22"
              field_mark="required"
              htmlautocomplete="new-password"
              label="password"
              name="password"
              placeholder="Secret"
              rules="required"
              :showPassword="this.dataToBind && this.dataToBind.hasOwnProperty('_showPassword_')"
              type="password"
              v-if="showPasswordField"></dg-text-field>
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 8 : 8" v-if="!selectedProfileId == '15'">
          <dg-select-field
              :control="control"
              :editable="editable"
              :field_span="22"
            :label_span="22"
              :options="$store.state['voip-vos-server-api'].dropDownList"
              :translateLabel='false'
              :translateLabels="false"
              @amUpdated="vosServerUpdated"
              field_mark="required"
              label="VOS Server"
              name="vos_server_id"
              placeholder="Select VOS Server"
              v-if="!isForCurrentActiveUser"
              rules="required"></dg-select-field>
        </el-col>
      </el-row>

      <el-row v-if="selectedProfileId == 9">
        <h6 class="border-bottom mb-3 font-weight-bold pb-2">Account Manager Profile Fields</h6>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 24 : 24">
          <dg-label-field :translate="false" class="ml-0 mr-1" label="Manage All Users"></dg-label-field>
          <el-switch v-model="dataModel.manage_all_users"></el-switch>
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 8 : 8">
          <dg-text-field
              :control="control"
              :field_span="22"
            :label_span="22"
              
              label="user_code"
              name="user_code"
              placeholder="enter code here"
              ></dg-text-field>
        </el-col>
      </el-row>
      <el-row v-if="selectedProfileId == 6">
        <h6 class="border-bottom mb-3 font-weight-bold pb-2">Customer Profile Fields</h6>
        <el-row>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 24 : 24">
            <dg-label-field :translate="false" class="ml-0 mr-1" label="LCR Feature"></dg-label-field>
            <el-switch v-model="dataModel.customerLCRFeature"></el-switch>
          </el-col>
        </el-row>
        <el-row class="mt-3">
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
            <dg-select-field
                :control="control"
                :defaultValue="customerSelectedFusion"
                :field_span="22"
                :label_span="22"
                :options="customerUnTakenFusionServersList"
                :translateLabel="false"
                :translateLabels="false"
                field_mark="required"
                label="Fusion Server"
                name="fusion_server_id"
                rules="required"></dg-select-field>
          </el-col>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
            <dg-text-field
                :control="control"
                :defaultValue="12"
                :field_span="22"
            :label_span="22"
                :translateLabel="false"
                field_mark="required"
                label="percent (%)"
                name="system_profit_percent"
                placeholder="12"
                rules="required"></dg-text-field>
          </el-col>
        </el-row>
        <el-row>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
            <dg-text-field
                :control="control"
                :defaultValue="customerVosUrl"
                :field_span="22"
            :label_span="22"
                :translateLabel="false"
                field_mark="required"
                label="VOS Recharge Link"
                name="vos_recharge_link"
                placeholder="https://182.24.11.14"
                rules="required"></dg-text-field>
          </el-col>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
            <dg-text-field
                :control="control"
                :defaultValue="customerVosUsername"
                :field_span="22"
            :label_span="22"
                :translateLabel="false"
                field_mark="required"
                label="VOS Username"
                name="vos_username"
                placeholder="username"
                rules="required"></dg-text-field>
          </el-col>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
            <dg-text-field
                :control="control"
                :defaultValue="customerVosPassword"
                :field_span="22"
            :label_span="22"
                :translateLabel="false"
                field_mark="required"
                label="VOS Password"
                name="vos_password"
                placeholder="secret"
                rules="required"></dg-text-field>
          </el-col>
        </el-row>
        <el-row>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 8 : 8">
          <dg-text-field
              :control="control"
              :field_span="22"
            :label_span="22"
              
              label="user_code"
              name="user_code"
              placeholder="enter code here"
              ></dg-text-field>
        </el-col>
        </el-row>
      </el-row>

      <div v-if="isSelectedUserGenerateLive">
        <h6 class="border-bottom mb-3 font-weight-bold pb-2">Generate Live User Fusion User</h6>
        <el-row class="mt-3" v-if="isSelectedUserGenerateLive">
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
            <dg-switch
                :control="control"
                :defaultValue="dataModel.get_balance_from_vos"
                :disabled="false"
                :field_span="22"
                :label_span="22"
                @amUpdated="getBalanceFromVosUpdated"
                :translateLabel="false"
                field_mark="required"
                label="Get Balance From VOS"
                name="get_balance_from_vos"
                rules="required">
              <template slot="field_note">
                <i class="ml-2" style="font-size: 10pt">Get Balance from VOS, if not, balance will be get from Fusion-Billing-Feature</i>
              </template>
            </dg-switch>
          </el-col>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
            <dg-select-field
                :control="control"
                :defaultValue="customerSelectedFusion"
                :disabled="editMode"
                :field_span="22"
            :label_span="22"
                :options="customerUnTakenFusionServersList"
                :translateLabel="false"
                :translateLabels="false"
                field_mark="required"
                label="Fusion Server"
                name="fusion_server_id"
                rules="required"></dg-select-field>
          </el-col>
        </el-row>
      </div>

      <div v-if="selectedProfileId == 5">
        <h6 class="border-bottom mb-3 font-weight-bold pb-2">Reseller Profile Fields</h6>
        <el-row>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6" v-if="!editResellerMode">
            <dg-select-field
                :control="control"
                :defaultValue="customerSelectedFusion"
                :disabled="editMode"
                :editable="!editResellerMode"
                :field_span="22"
            :label_span="22"
                :options="customerUnTakenFusionServersList"
                :rules="(!editResellerMode)? '' : 'required'"
                :translateLabel="false"
                :translateLabels="false"
                field_mark="required"
                label="Fusion Server"
                name="fusion_server_id"></dg-select-field>
          </el-col>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
            <dg-text-field
                :control="control"
                :defaultValue="12"
                :field_span="22"
            :label_span="22"
                :translateLabel="false"
                field_mark="required"
                label="percent (%)"
                name="system_profit_percent"
                placeholder="12"
                rules="required"></dg-text-field>
          </el-col>
        </el-row>
        <el-row>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
            <dg-text-field
                :control="control"
                :field_span="22"
            :label_span="22"
                :translateLabel="false"
                field_mark="required"
                label="VOS Link"
                name="vos_recharge_link"
                placeholder="https://vos-link-to-recharge.com"
                rules="required"></dg-text-field>
          </el-col>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
            <dg-text-field
                :control="control"
                :defaultValue="customerVosUsername"
                :field_span="22"
            :label_span="22"
                :translateLabel="false"
                field_mark="required"
                label="VOS Username"
                name="vos_username"
                placeholder="username"
                rules="required"></dg-text-field>
          </el-col>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
            <dg-text-field
                :control="control"
                :defaultValue="customerVosPassword"
                :field_span="22"
            :label_span="22"
                :translateLabel="false"
                field_mark="required"
                label="VOS Password"
                name="vos_password"
                placeholder="secret"
                rules="required"></dg-text-field>
          </el-col>
        </el-row>
      </div>

      <el-row>
        <el-col :span="24" class="mt-5 border-top" v-loading="loadingRequests">
          <el-col :class="$langConfig.cssClass" :span="20" class="mt-4">
            <dg-label-field class="error-field-validate-message" label="fields_do_not_match_the_required_criteria"
                            v-show="!this.validData"></dg-label-field>
          </el-col>
          <el-col :span="4" class="pt-3 text-right">
            <el-button
                @click="createModule"
                :text="actionButtonLabel"
                :type="actionButtonType"
                icon="el-icon-edit mr-2">{{actionButtonLabel}}</el-button>
          </el-col>
        </el-col>
      </el-row>
    </div>
    <div v-else>
      <h5 class="text-success" v-if="profileChanged">
        Profile Updated <i class="el-icon-circle-check text-success"></i> <br>
        <small>You have to logout and login to see changes</small>
      </h5>
    </div>
  </div>
</template>

<script>


import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
import module from './../index.js'
import iziToast from 'izitoast'
import countriesList from '@/json/countriesList.json'

export default {
  mixins: [fieldController],
  props: {
    editable: {
      required: false,
    },
    formTitle: {
      required: false,
    },
    isForCurrentActiveUser: {
      required: false,
      type: Boolean,
      default: true
    },
    showPasswordField: {
      required: true,
      type: Boolean
    },
    editMode: {
      required: true,
      type: Boolean
    },
    onEditCallback: {
      required: false,
      default: () => {

      }
    },
    onCreateCallback: {
      required: false
    }
  },
  data() {
    return {
      isUserSales: $store.getters['user-state/isUserSales'],
      isUserAccountManager: $store.getters['user-state/isUserAccountManager'],
      isUserPlatformEmployee: $store.getters['user-state/isUserPlatformEmployee'],
      editResellerMode: false,
      control: this,
      customerSelectedFusion: null,
      customerUnTakenFusionServersList: [],
      customerVosUrl: null,
      customerVosUsername: null,
      customerVosPassword: null,
      dataModel: {
        get_balance_from_vos: false
      },
      countriesList: countriesList,
      userProfileFirstUpdate: false,
      selectedProfileId: null,
      subscribePlansList: [],
      profileCreated: false,
      profileChanged: false,
      amReady: false,
      isSelectedUserReseller: false,
      isSelectedUserCustomer: false,
      isSelectedUserGenerateLive: false,
      isSelectedUserMrt: false,
      originFusionServer: null,
      module: {...module},
      profilesOptionsList: []
    }
  },
  beforeMount() {
    
    if (this.isUserSales) {
      this.profilesOptionsList = [
        {
          'label': 'VoIP Customer',
          'value': '6'
        },]
    } else if(this.isUserAccountManager){

      this.profilesOptionsList = [
        {
          'label': 'VoIP Customer',
          'value': '6'
        },
        {
          'label': 'VoIP Reseller',
          'value': '5'
        }]

      }
      else if(this.isUserPlatformEmployee){
        
        this.profilesOptionsList = $store.state['user-state'].usersProfilesForEmploy
      }
      else if(this.isUserSales){
        
        this.profilesOptionsList = $store.state['user-state'].usersProfilesForSales
      }
      
      else {
      this.profilesOptionsList = $store.state['user-state'].usersProfiles

    }

    if (this.dataToBind) {
      if (this.dataToBind.user_profile_id == 12) {}
    }
  },
  mounted() {
    
    $store.dispatch('voip-vos-server-api/getDropDownList').then(() => {
      if (this.dataToBind) {
        this.selectedProfileId = this.dataToBind.user_profile_id
        this.isSelectedUserAccountManager = $store.getters['user-state/isProfileIdForAccountManager'](this.selectedProfileId)
        this.isSelectedUserReseller = $store.getters['user-state/isProfileIdForReseller'](this.selectedProfileId)
        this.isSelectedUserCustomer = $store.getters['user-state/isProfileIdForCustomer'](this.selectedProfileId)
        this.isSelectedUserGenerateLive = $store.getters['user-state/isProfileIdForGenerateLive'](this.selectedProfileId)
        this.isSelectedUserMrt = $store.getters['user-state/isProfileIdForMrt'](this.selectedProfileId)

        if (!this.dataToBind.hasOwnProperty('_NEW_USER_')) {
          this.amReady = true
          if (this.isSelectedUserGenerateLive) {
            this.bindGenerateLiveUserFields()
            $vue.nextTick(() => {
              this.bindController()
            })
          } else if (this.isSelectedUserReseller) {
            this.bindResellerFields()
            $vue.nextTick(() => {
              this.bindController()
            })
          } else if (this.isSelectedUserAccountManager) {
            this.bindAccountManagerFields()
            $vue.nextTick(() => {
              this.bindController()
            })
          } else if (this.isSelectedUserCustomer) {
            this.getUnTakenFusionServersList()
            this.bindCustomerFields()
            this.userHasModuleApiCall({id: this.dataToBind.id, module: 'voip-lcr-menu'}).then((r) => {
              $vue.set(this.dataModel, 'customerLCRFeature', r === 1)
              $vue.nextTick(() => {
                this.bindController()
              })
            })
          } else {
            $vue.nextTick(() => {
              this.bindController()
            })
          }
        } else {
          this.amReady = true
          $vue.nextTick(() => {
            this.bindController()
          })
        }


      } else {
        this.amReady = true
    
        // this.fields['user_profile_id'].field.field_value = '4';
        // this.fields['user_profile_id'].field.updateValue()
      }
    })
  },
  computed: {
    ...$mapState('ajaxManager', ['loadingRequests']),
    ...$mapState('datacloud-entity-category-state', ['categoriesSuggestion']),
    ...$mapState('datacloud-entity-state', ['openedEntity']),
    actionButtonLabel: function () {
      if (!this.editMode) {
        return 'create';
      } else {
        return 'update'
      }
    },
    actionButtonType: function () {
      if (!this.validData) {
        return 'danger';
      } else {
        return 'primary app-bg-primary'
      }
    }
  },
  methods: {
    getBalanceFromVosUpdated (inputField) {
      let value = inputField.field.field_value
      let id = this.dataToBind.id
      this.updateGenerateLiveUser({id, data: {get_balance_from_vos: value}})
    },
    vosServerUpdated (inputField) {
      let value = inputField.field.field_value
    },
    updateCustomerLCRFeature() {
      let data = {
        user_id: this.dataToBind.id,
        modules: [
          'voip-lcr-menu',
          'voip-lcr-top-destinations'
        ]
      }
      if (this.dataModel.customerLCRFeature) {
        this.giveUserModules({data})
      } else {
        this.removeUserModules({data})
      }
    },
    bindCustomerFields() {
      this.getCustomerFields({id: this.dataToBind.id}).then((r) => {
        this.fields['vos_recharge_link'].field.field_value = r.vos_recharge_link
        this.fields['vos_recharge_link'].field.updateValue()

        this.fields['vos_username'].field.field_value = r.vos_username
        this.fields['vos_username'].field.updateValue()

        this.fields['vos_password'].field.field_value = r.vos_password
        this.fields['vos_password'].field.updateValue()

        this.fields['system_profit_percent'].field.field_value = r.system_profit_percent
        this.fields['system_profit_percent'].field.updateValue()

        this.fields['fusion_server_id'].field.field_value = r.fusion_server_name
        this.fields['fusion_server_id'].field.updateValue()
        this.customerSelectedFusion = r.fusion_server_name
        this.originFusionServer = r.fusion_server_name
        $vue.set(this.dataModel, 'using_private_rate', r.using_private_rate === 1)
      })
    },
    bindGenerateLiveUserFields() {
      this.getGenerateLiveUserFields({id: this.dataToBind.id}).then((r) => {
        this.fields['fusion_server_id'].field.field_value = r.fusion_server_name
        this.fields['fusion_server_id'].field.updateValue()
        //this.customerSelectedFusion = r.fusion_server_name
        $vue.set(this.dataToBind, 'get_balance_from_vos', r.get_balance_from_vos === 1)
        $vue.set(this.dataModel, 'using_private_rate', r.using_private_rate === 1)
      })
    },
    bindAccountManagerFields() {
      this.getAccountManagerFields({id: this.dataToBind.id}).then((r) => {
        $vue.set(this.dataModel, 'manage_all_users', r.manage_all_users === 1)
      })
    },
    bindResellerFields() {
      this.getResellerFields({id: this.dataToBind.id}).then((r) => {

        this.editResellerMode = true

        this.fields['vos_recharge_link'].field.field_value = r.data.vos_recharge_link
        this.fields['vos_recharge_link'].field.updateValue()

        this.fields['vos_username'].field.field_value = r.data.vos_username
        this.fields['vos_username'].field.updateValue()

        this.fields['vos_password'].field.field_value = r.data.vos_password
        this.fields['vos_password'].field.updateValue()

        this.fields['system_profit_percent'].field.field_value = r.data.system_profit_percent
        this.fields['system_profit_percent'].field.updateValue()

        this.fields['fusion_server_id'].field.field_value = r.fusion_server_name
        this.fields['fusion_server_id'].field.updateValue()
        // this.customerSelectedFusion = r.fusion_server_name
      })
    },
    profileUpdated(inputField) {
      delete this.dataModel['customerLCRFeature']
      let value = inputField.field.field_value
      if (value) {
        this.selectedProfileId = value
      }

      this.isSelectedUserReseller = $store.getters['user-state/isProfileIdForReseller'](this.selectedProfileId)
      this.isSelectedUserCustomer = $store.getters['user-state/isProfileIdForCustomer'](this.selectedProfileId)
      this.isSelectedUserMrt = $store.getters['user-state/isProfileIdForMrt'](this.selectedProfileId)
      this.isSelectedUserGenerateLive = $store.getters['user-state/isProfileIdForGenerateLive'](this.selectedProfileId)

      if (this.isSelectedUserCustomer || this.isSelectedUserReseller) {
        this.getUnTakenFusionServersList()
      }
      if (this.isSelectedUserGenerateLive) {
        this.getUnTakenByGenerateLiveUsersList()
      }


      if (!this.userProfileFirstUpdate) {
        this.userProfileFirstUpdate = true
        if (this.dataToBind) {
          this.selectedProfileId = this.dataToBind.user_profile_id
          this.fields['user_profile_id'].field.field_value = this.selectedProfileId
          this.fields['user_profile_id'].field.updateValue()
          if (!this.dataToBind.hasOwnProperty('_NEW_USER_')) {
            if (this.isSelectedUserReseller) {
              this.bindResellerFields()
            } else if (this.isSelectedUserCustomer) {
              this.bindCustomerFields()
            }
          }
        }
      }
    },
    getFormTitle() {
      if (this.formTitle) {
        return this.formTitle
      } else {
        return ((!this.editMode) ? this.$ml.get('create') : this.$ml.get('edit')) + ' ' + this.module.info.caption
      }
    },
    ...$mapActions('user-generate-live-features-api', {
      getGenerateLiveUserFields: 'get',
      updateGenerateLiveUser: 'update'
    }),
    ...$mapActions('user-customer-features-api', {
      getCustomerFields: 'get',
      updateCustomerFields: 'update'
    }),
    ...$mapActions('user-reseller-features-api', {
      prepareNewResellerFields: 'create',
      getResellerFields: 'get',
      updateResellerFields: 'update'
    }),
    ...$mapActions('user-api', {
      getDropDownUnTakenByCustomerList: 'getDropDownUnTakenByCustomerList',
      dropDownUnTakenByGenerateLiveUsersList: 'dropDownUnTakenByGenerateLiveUsersList',
      getAccountManagerFields: 'getAccountManagerFields',
      updateAccountManagerFields: 'updateAccountManagerFields',
      userHasModuleApiCall: 'userHasModule',
      giveUserModules: 'giveUserModules',
      removeUserModules: 'removeUserModules'
    }),
    getUnTakenByGenerateLiveUsersList() {
      this.dropDownUnTakenByGenerateLiveUsersList({}).then(r => {
        this.customerUnTakenFusionServersList = r
      })
    },
    getUnTakenFusionServersList() {
      this.getDropDownUnTakenByCustomerList({}).then(r => {
        this.customerUnTakenFusionServersList = r
      })
    },
    validateResellerUserCreation() {
      /*let f1 = this.standaloneFieldValidate(this.fields['vos_link'], 'required')
      let f2 = this.standaloneFieldValidate(this.fields['system_profit_percent'], 'required')

      if (!f1 || !f2) {
        return false
      }*/
      return true
    },
    createModule() {
      this.validateFields().then(result => {
        if (this.selectedProfileId == 5) {
          if (!this.validateResellerUserCreation()) {
            return
          }
        }

        let context = this;
        let data = {data: this.dataModel};

        if (this.editMode) {
          delete this.dataModel.username
        }

        if (this.editMode) {
          data.id = this.dataToBind.id;
        }

        if (!result) return

        let api = null
        if (this.isForCurrentActiveUser) {
          api = (this.editMode) ? 'updateLoggedInProfile' : 'create';
        } else {
          api = (this.editMode) ? 'update' : 'create';
        }

        this.$store.dispatch(this.module.info.name + '-api/' + api, data).then(response => {
          this.selectedProfileId = 0

          let createdUserId = response.data.id

          if (this.isSelectedUserAccountManager) {
            if (api == 'create') {
            } else {
              let apiParams = {
                id: this.dataToBind.id,
                data: {
                  manage_all_users: this.dataModel.manage_all_users,
                }
              }
              // data.fusion_server_id = this.dataModel.fusion_server_id
              this.updateAccountManagerFields(apiParams)
            }
          }

          if (this.isSelectedUserReseller) {
            if (api == 'create') {
              this.getUnTakenFusionServersList()
            } else {
              let data = {
                system_profit_percent: this.dataModel.system_profit_percent,
                user_id: this.dataToBind.id,
                vos_recharge_link: this.dataModel.vos_recharge_link,
                vos_username: this.dataModel.vos_username,
                vos_password: this.dataModel.vos_password
              }

              // data.fusion_server_id = this.dataModel.fusion_server_id
              this.updateResellerFields({data})
            }
          }

          if (this.isSelectedUserCustomer) {
            let data = {
              using_private_rate: (this.dataModel.using_private_rate) ? 1 : 0
            }
            if (api == 'create') {
              this.getUnTakenFusionServersList()
            } else {
              let data = {
                system_profit_percent: this.dataModel.system_profit_percent,
                user_id: this.dataToBind.id,
                vos_recharge_link: this.dataModel.vos_recharge_link,
                vos_username: this.dataModel.vos_username,
                vos_password: this.dataModel.vos_password,
                fusion_server_id: this.dataModel.fusion_server_id
              }
              /*if (this.originFusionServer == 'NO FUSION') {

              }*/

              this.updateCustomerLCRFeature({data})
              this.updateCustomerFields({data})
            }
          }


          iziToast.success({
            title: this.$ml.get('successfully'),
            message: '',
            position: 'topRight',
            close: false,
            timeout: 1900,
            animateInside: true
          });

          if (this.editMode) {
            this.profileChanged = true
          } else {
            this.profileCreated = true
          }


          if (context.editMode && context.onEditCallback) {
            context.onEditCallback(response.data)
          } else {
            this.amReady = false
            $vue.nextTick(() => {
              context.amReady = true
              if (context.onCreateCallback) {
                context.onCreateCallback(response.data)
              }
            })
          }
        }).catch(error => {
          iziToast.warning({
            title: 'Oops ... failed',
            message: '',
            position: 'topRight',
            close: false,
            timeout: 1900,
            animateInside: true
          });
          console.log('catched error', error)
          this.setfieldsErrorMessage({
            fieldsErrors: error.response.data
          }, this.arefieldsValid);
        })

      })
    }
  }
}
</script>
